import React, { Component } from "react"
import { AppState } from "src/store"
import { connect } from "react-redux"
import ClientPortalEmployeeAccessLevelAreaTypes from "./Types/ClientPortalEmployeeAccessLevelAreaTypes"
import mutator from "src/utilities/mutator"
import snackBar from "src/utilities/snackBar/SnackBar"
import AxiosConfig from "src/utilities/AxiosConfig"
import axios from "axios"
import APIResponseTypes from "./Types/APIResponseTypes"
import EALAService from "./Utils/EALAService"
import EALATable from "./EALATable/EALATable"
import AddEALA from "./AddEALA/AddEALA"
import EALAHeader from "./EALAHeader/EALAHeader"
import EditDefaultArea from "./EditDefaultArea/EditDefaultArea"
import StateHierarchyTree from "./Utils/Trees/StateHierarchyTree"
import ProfitCenterHierarchyTree from "./Utils/Trees/ProfitCenterHierarchyTree"
import FirstLoadLoader from "./Loaders/FirstLoadLoader/FirstLoadLoader"
import PromotingOrDemotingLoader from "./Loaders/PromotingOrDemotingLoader/PromotingOrDemotingLoader"
import EALABrokenRecord from "./EALABrokenRecord/EALABrokenRecord"
import EALAAddServiceArea from "./EALAAddServiceArea/EALAAddServiceArea"
import "./EALA.css"

interface Props {
    targetUserId: number
    loggedInUserId: number
}

interface State {
    AccessLevelID: number
    ealas: ClientPortalEmployeeAccessLevelAreaTypes[]
    addEala: boolean
    editDefaultArea: boolean
    treeStateID: number
    treeProfitCenterID: number
    firstLoad: boolean
    addBusy: boolean
    editBusy: boolean
    updateUserAction: number
    editDefaultAreaBusy: boolean
    brokenRecord: boolean
    ealaToAddServiceAreaTo: ClientPortalEmployeeAccessLevelAreaTypes | null
}

class EALA extends Component<Props, State> {

    preRender: { key: string, value?: any }[] = []
    history = 0

    state = {
        AccessLevelID: 0,
        ealas: [],
        addEala: false,
        editDefaultArea: false,
        treeStateID: -1,
        treeProfitCenterID: -1,
        firstLoad: true,
        addBusy: false,
        editBusy: false,
        updateUserAction: 0,
        editDefaultAreaBusy: false,
        brokenRecord: false,
        ealaToAddServiceAreaTo: null
    }

    componentDidMount() {
        this.go()
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: { key: string, value?: any }[]) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    /* A function that takes a string and two arguments. It then calls a function with the name of the
    string and passes the two arguments. */
    callFunction = (functionToCall: string, arg1: any, arg2: any, arg3: any) => {
        //@ts-ignore
        this[functionToCall](arg1, arg2, arg3)
    }

    go = () => {
        const { targetUserId } = this.props
        const { sortByDefault, buildEalaTable, getDefaultEALA } = EALAService
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/getEmployeeAccessLevelAreasByEmployeeID/${targetUserId}`, AxiosConfig.configValue("min"))
            .then(res => {
                const response: APIResponseTypes = res.data
                if (response.Error.Success) {
                    const ealas: ClientPortalEmployeeAccessLevelAreaTypes[] = sortByDefault(res.data.Data.accessLevels)
                    if (getDefaultEALA(ealas).EmployeeAccessLevelAreaID > 0) {
                        this.preRender.push({ key: "ealas", value: ealas }, { key: "firstLoad", value: false }, { key: "AccessLevelID", value: ealas[0].AccessLevelID })
                    } else {
                        snackBar({ type: "error", text: "There is an issue with the employee record", timeout: 5000 })
                        this.manageState([{ key: "firstLoad", value: false }, { key: "brokenRecord", value: true }])

                    }
                    EALAService.ealas = []
                    //@ts-ignore
                    EALAService.ealas = ealas
                    buildEalaTable(ealas).then(() => {
                        this.getReferenceData()
                    })
                } else {
                    this.manageState([{ key: "firstLoad", value: false }])
                    snackBar({ type: "error", text: "Failed to getEALAS() from API", timeout: 5000 })
                }
            }).catch(() => {
                this.manageState([{ key: "firstLoad", value: false }])
                snackBar({ type: "error", text: "Failed to getEALAS()", timeout: 5000 })
            })
    }

    getReferenceData = () => {
        const { setUpTables, normalizeReferenceData } = EALAService
        axios.get(`${process.env.REACT_APP_API_URL}/api/user/getEmployeeAccessLevelAreaReference`, AxiosConfig.configValue("min"))
            .then(res => {
                const response: APIResponseTypes = res.data
                if (response.Error.Success) {
                    const { states, profitCenters, serviceAreas, accessLevels } = response.Data.reference
                    EALAService.reference.accessLevels = JSON.parse(JSON.stringify(accessLevels))//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    EALAService.reference.accessLevelsExtended = accessLevels
                    EALAService.reference.accessLevelsExtended.unshift({ accessDesc: "All", accessLevelID: -1 })
                    EALAService.reference.states = states
                    EALAService.reference.profitCenters = profitCenters
                    EALAService.reference.serviceAreas = serviceAreas
                    EALAService.normalizedReferenceData.states = normalizeReferenceData("StateID", "StateName", states)
                    EALAService.normalizedReferenceData.profitCenters = normalizeReferenceData("ProfitCenterID", "ProfitCenterLongDesc", profitCenters)
                    EALAService.normalizedReferenceData.serviceAreas = normalizeReferenceData("ServiceAreaID", "ServiceAreaLongDesc", serviceAreas)
                    setUpTables(states, profitCenters, serviceAreas)
                    this.manageState(this.preRender)
                } else {
                    this.manageState([{ key: "firstLoad", value: false }])
                    snackBar({ type: "error", text: "Failed to getReferenceData() from API", timeout: 5000 })
                }

            }).catch((/*err*/) => {
                //console.log(err)
                this.manageState([{ key: "firstLoad", value: false }])
                snackBar({ type: "error", text: "Failed to getReferenceData()", timeout: 5000 })
            })
    }

    editEALAS = (ealas: ClientPortalEmployeeAccessLevelAreaTypes[], stateKey?: string, overrideDirtyCheck?: boolean) => {
        const customStateKey = stateKey ? stateKey : "editBusy"
        this.manageState([{ key: customStateKey, value: true }])
        const { editEALASSaveSetup, sortByDefault, buildEalaTable, checkForDropEala, setUpTables } = EALAService
        let newEalas: ClientPortalEmployeeAccessLevelAreaTypes[] = []
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/editEmployeeAccessLevelAreas`, editEALASSaveSetup(ealas, overrideDirtyCheck), AxiosConfig.configValue("min"))
            .then(res => {
                const response: APIResponseTypes = res.data
                if (response.Error.Success) {
                    newEalas = sortByDefault(res.data.Data.accessLevels)
                    EALAService.ealas = []
                    //@ts-ignore
                    EALAService.ealas = newEalas
                } else {
                    this.manageState([{ key: customStateKey, value: false }])
                    snackBar({ type: "error", text: "Failed to editEALAS() from API", timeout: 5000 })
                }
            }).then(() => {
                let ealasToDelete: number[] = []
                for (let i = 0; i < ealas.length; i++) {
                    const eala = ealas[i]
                    if (checkForDropEala(eala)) {
                        ealasToDelete.push(eala.EmployeeAccessLevelAreaID)
                    }
                }
                if (ealasToDelete.length > 0) {
                    this.deleteEALAS(ealasToDelete, ealas[0].EmployeeID)
                } else {
                    this.manageState([{ key: "ealas", value: newEalas }, { key: customStateKey, value: false }, { key: "ealaToAddServiceAreaTo", value: null }])
                    buildEalaTable(newEalas).then(() => {
                        setUpTables(EALAService.reference.states, EALAService.reference.profitCenters, EALAService.reference.serviceAreas)
                    })
                }
            }).catch(() => {
                this.manageState([{ key: customStateKey, value: false }])
                snackBar({ type: "error", text: "Failed to editEALAS()", timeout: 5000 })
            })
    }

    deleteEALAS = (EALASToDelete: number[], EmployeeID: number) => {
        const { editBusy } = this.state
        if (!editBusy) {
            this.manageState([{ key: "editBusy", value: true }])
        }
        const rb = {
            EALASToDelete: EALASToDelete,
            EmployeeID: EmployeeID
        }
        const { sortByDefault, buildEalaTable, setUpTables } = EALAService
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/deleteEmployeeAccessLevelAreas`, rb, AxiosConfig.configValue("min"))
            .then(res => {
                const response: APIResponseTypes = res.data
                if (response.Error.Success) {
                    const newEalas: ClientPortalEmployeeAccessLevelAreaTypes[] = sortByDefault(res.data.Data.accessLevels)
                    EALAService.ealas = []
                    //@ts-ignore
                    EALAService.ealas = newEalas
                    this.manageState([{ key: "ealas", value: newEalas }, { key: "editBusy", value: false }])
                    buildEalaTable(newEalas).then(() => {
                        setUpTables(EALAService.reference.states, EALAService.reference.profitCenters, EALAService.reference.serviceAreas)
                    })
                } else {
                    this.manageState([{ key: "editBusy", value: false }])
                    snackBar({ type: "error", text: "Failed to deleteEALAS() from API", timeout: 5000 })
                }
            }).catch(() => {
                this.manageState([{ key: "editBusy", value: false }])
                snackBar({ type: "error", text: "Failed to deleteEALAS()", timeout: 5000 })
            })

    }

    addEALAS = () => {
        this.manageState([{ key: "addBusy", value: true }])
        const { addEALASSaveSetup, sortByDefault, buildEalaTable, setUpTables } = EALAService
        const { targetUserId } = this.props
        const { AccessLevelID } = this.state
        const rb = addEALASSaveSetup(targetUserId, AccessLevelID)
        // console.log("addEALASSaveSetup", rb)
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/addEmployeeAccessLevelAreas`, rb, AxiosConfig.configValue("min"))
            .then(res => {
                const response: APIResponseTypes = res.data
                if (response.Error.Success) {
                    const newEalas: ClientPortalEmployeeAccessLevelAreaTypes[] = sortByDefault(res.data.Data.accessLevels)
                    EALAService.ealas = []
                    //@ts-ignore
                    EALAService.ealas = newEalas
                    this.manageState([{ key: "ealas", value: newEalas }, { key: "addEala", value: false }, { key: "addBusy", value: false }])
                    buildEalaTable(newEalas).then(() => {
                        setUpTables(EALAService.reference.states, EALAService.reference.profitCenters, EALAService.reference.serviceAreas)
                    })
                } else {
                    this.manageState([{ key: "addEala", value: false }, { key: "addBusy", value: true }])
                    snackBar({ type: "error", text: "Failed to addEALAS() from API", timeout: 5000 })
                }
            }).catch(() => {
                this.manageState([{ key: "addBusy", value: false }])
                snackBar({ type: "error", text: "Failed to addEALAS()", timeout: 5000 })
            })
    }

    updateUserType = (newAccessLevelID: number, oldAccessLevelID: number) => {
        this.manageState([{ key: "updateUserAction", value: newAccessLevelID > oldAccessLevelID ? -1 : 1 }])
        const { targetUserId } = this.props
        const { sortByDefault, buildEalaTable, setUpTables } = EALAService
        const rb = { AccessLevelID: newAccessLevelID, EmployeeID: targetUserId }
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/updateUserType`, rb, AxiosConfig.configValue("min"))
            .then(res => {
                const response: APIResponseTypes = res.data
                if (response.Error.Success) {
                    const newEalas: ClientPortalEmployeeAccessLevelAreaTypes[] = sortByDefault(res.data.Data.accessLevels)
                    EALAService.ealas = []
                    //@ts-ignore
                    EALAService.ealas = newEalas
                    this.manageState([{ key: "ealas", value: newEalas }, { key: "updateUserAction", value: 0 }, { key: "AccessLevelID", value: newEalas[0].AccessLevelID }])
                    buildEalaTable(newEalas).then(() => {
                        setUpTables(EALAService.reference.states, EALAService.reference.profitCenters, EALAService.reference.serviceAreas)
                    })
                } else {
                    this.manageState([{ key: "updateUserAction", value: 0 }])
                    snackBar({ type: "error", text: "Failed to updateUserType() from API", timeout: 5000 })
                }
            }).catch(() => {
                this.manageState([{ key: "updateUserAction", value: 0 }])
                snackBar({ type: "error", text: "Failed to updateUserType()", timeout: 5000 })
            })
    }

    render() {
        const { targetUserId, loggedInUserId } = this.props
        const {
            AccessLevelID,
            ealas,
            addEala,
            editDefaultArea,
            treeStateID,
            treeProfitCenterID,
            firstLoad,
            addBusy,
            editBusy,
            updateUserAction,
            brokenRecord,
            ealaToAddServiceAreaTo
        } = this.state
        const { filterEALASByAccessLevelID, getDefaultEALA, checkIfEditIsDirty, lookupHashTableItem } = EALAService
        const defaultEALA = getDefaultEALA(ealas)
        const editIsDirty = checkIfEditIsDirty(ealas)
        const promotingOrDemoting = (updateUserAction < 0 || updateUserAction > 0)
        const fade = promotingOrDemoting
        const isNaughty = targetUserId === loggedInUserId

        //console.log("EALA state", this.state)
        //console.log("EALA props", this.props)
        // console.log("EALA EALAService", EALAService)
        //console.log("EALAService.hierarchyTrees", EALAService.hierarchyTrees)
        //console.log("EALAService.reference", EALAService.reference)

        return (
            <div className="EALA">
                {!firstLoad && !brokenRecord && <>
                    <EALAHeader
                        manageParentState={this.manageState}
                        callParentFunction={this.callFunction}
                        AccessLevelID={AccessLevelID}
                        ealas={ealas}
                        editBusy={editBusy}
                        editIsDirty={editIsDirty}
                        fade={fade}
                        isNaughty={isNaughty}

                    />
                    <EALATable
                        ealas={filterEALASByAccessLevelID(ealas, AccessLevelID)}
                        manageParentState={this.manageState}
                        AccessLevelID={AccessLevelID}
                        editIsDirty={editIsDirty}
                        fade={fade}
                        isNaughty={isNaughty}
                    />
                    {addEala &&
                        <AddEALA
                            manageParentState={this.manageState}
                            addEALAS={this.addEALAS}
                            AccessLevelID={AccessLevelID}
                            addBusy={addBusy}
                        />}
                    {editDefaultArea &&
                        <EditDefaultArea
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                            defaultEALA={defaultEALA}
                            AccessLevelID={AccessLevelID}
                        />}
                    {treeStateID > -1 &&
                        <StateHierarchyTree
                            manageParentState={this.manageState}
                            treeStateID={treeStateID}
                        />}
                    {treeProfitCenterID > -1 &&
                        <ProfitCenterHierarchyTree
                            manageParentState={this.manageState}
                            treeProfitCenterID={treeProfitCenterID}
                        />}
                    {ealaToAddServiceAreaTo &&
                        <EALAAddServiceArea
                            manageParentState={this.manageState}
                            callParentFunction={this.callFunction}
                            //@ts-ignore
                            eala={ealaToAddServiceAreaTo}
                        />
                    }
                </>}
                {firstLoad && <FirstLoadLoader />}
                {promotingOrDemoting && <PromotingOrDemotingLoader updateUserAction={updateUserAction} />}
                {brokenRecord && <EALABrokenRecord />}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    loggedInUserId: parseInt(state.user.userId)
})

export default connect(mapStateToProps)(EALA)